class AccountSection extends HTMLElement {
  constructor() {
    super();

    this.navBlock = this.querySelector(".js-nav-block");
  }

  connectedCallback() {
    this._setSpacings();
    window.addEventListener('resize', this._setSpacings.bind(this));
  }

  _setSpacings() {
    this._setNavBlockOffsetTop();
    this._addStickyNavSpace()
  }

  _setNavBlockOffsetTop() {
    const header = document.querySelector(".js-header-main");
    this.navBlock.style.setProperty('--offset-top', header.offsetHeight + 32 + "px");
  }

  _addStickyNavSpace() {
    const stickyNav = document.querySelector('.js-sticky-nav-mob');
    document.body.style.marginBottom = stickyNav.offsetHeight + 'px';
  }
}

customElements.define('account-section', AccountSection);